<xm-ee-basic-widget
  [options]="options"
  [controlValue]="controlValue"
  (valueChanged)="changeText($event)"
></xm-ee-basic-widget>

